/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import useDashboardContext from "routes/utils/context/useDashboardContext";

const useSpaceCoordinatorCampus = ({
    changeFilter, isCampusCoordinator
}) => {
    const { userCampusId } = useDashboardContext();
    useEffect(() => {
        if (isCampusCoordinator && userCampusId)
            changeFilter("campusId", userCampusId);
    }, [userCampusId]);
}

export default useSpaceCoordinatorCampus;